module.exports = __webpack_public_path__ + "7cefbacb111dd939d855c76d4985ac60.png";